import type { ConditionOperator } from '@reach/shared-types/conditions';
import type { BuilderConditionValue } from '../segment-builder.types';
import styles from '../SegmentVisualBuilder.module.css';
import { getResolvedDatePreviewText } from './date-preview';

export function ResolvedDatePreview({
  operator,
  value,
}: {
  operator: ConditionOperator;
  value: BuilderConditionValue | undefined;
}) {
  const previewText = getResolvedDatePreviewText(operator, value);

  if (!previewText) return null;

  return <div className={styles.resolvedDatePreview}>{previewText}</div>;
}
